import React from 'react';

import styled from 'styled-components';

const VideoPlayerPopStyle = styled.div`
  .video-mask {
    position: fixed;
    inset: 0;
    z-index: 1000;
    height: 100%;
    background-color: #00000073;
  }
  .video-wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60vw;
    height: 500px;
    z-index: 100000;
    #my-player {
      width: 100%;
      height: 100%;
    }
    #video-iframe {
      width: 100%;
      height: 100%;
    }
  }
  .close-btn {
    position: absolute;
    top: -50px;
    right: -50px;
    cursor: pointer;
    border-radius: 50%;
    padding: 2px;
  }
`;

const VideoPlayerPop = ({ way, url, poster, setVideoData }) => {
  return (
    <VideoPlayerPopStyle>
      <section className="video-mask" onClick={() => setVideoData(null)}></section>
      <section className="video-wrapper">
        <img
          src="//static.szlcsc.com/ecp/assets/web/layout/videoPlayerDialog/images/close.svg"
          loading="lazy"
          className="close-btn"
          onClick={() => setVideoData(null)}
        />
        {way === 'file' ? (
          <video
            id="my-player"
            className="video-js"
            width="100%"
            height="100%"
            autoplay="autoplay"
            controls
            poster={poster}
          >
            <source src={url} type="video/mp4" />
            <p className="vjs-no-js">
              您目前的浏览器版本过低，建议下载后观看
              <a data-spm="xz" href="{{ wwwTemplateResource }}/190914_Gigadevice_V2.mp4" target="_blank"></a>
            </p>
          </video>
        ) : (
          <iframe id="video-iframe" frameBorder="0" src={url} allowFullScreen="true"></iframe>
        )}
      </section>
    </VideoPlayerPopStyle>
  );
};

export default VideoPlayerPop;
